import { z } from "zod"

const pointSchema = z.object({
    lat: z.number(),
    lon: z.number(),
    address: z.string(),
    index: z.number(),
    title: z.string()
})
export enum Days {
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
    Sunday = 'Sunday'
}

export const TripFormSchema = z.object({
    title: z.string(),
    departAt: z.date(),
    arriveAt: z.date(),
    status: z.string().optional(),
    maxSubscribers: z.number().default(13),
    days: z.array(z.enum(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])).refine(days => {
        return !!days.length
    },
        { message: "at least one day must be selected" }),
    points: z.array(pointSchema).refine(points => {
        if (points.length < 2) return false
        return points[0]?.lon !== 0 || points[1]?.lon !== 0
    },
        { message: "at least two points must be intered" }),
})

export type Trip = z.infer<typeof TripFormSchema>
export type TripPoint = z.infer<typeof pointSchema>